import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import OpzioniPrenotazione from "@/pages/OpzioniPrenotazione";
import AccontiSaldi from "@/pages/AccontiSaldi";
import Annuale from "@/pages/Annuale";
import Calendario from "@/pages/Calendario";
import Trasferimenti from "@/pages/Trasferimenti";
import Proprieta from "@/pages/Proprieta";
import Disponibilita from "@/pages/Disponibilita";
import Ospiti from "@/pages/Ospiti";
import Money from "@/pages/Money";
import Report from "@/pages/Report";
import Affitti from "@/pages/Affitti";
import Staff from "@/pages/Staff";
import Bar from "@/pages/Bar";
import SpeseGuesthouse from "@/pages/SpeseGuesthouse";
import Amministrazione from "@/pages/Amministrazione";
import Mira from "@/pages/Mira";
import Settings from "@/pages/Settings";
import Utenti from "@/pages/Utenti";
import Agenzie from "@/pages/Agenzie";
import Voucher from "@/pages/Voucher";
import VoucherGroup from "@/pages/VoucherGroup";
import Ricevuta from "@/pages/Ricevuta";
import RicevutaGroup from "@/pages/RicevutaGroup";
import Fatture from "@/pages/Fatture";
import Fattura from "@/pages/Fattura";
import Previsionale from "@/pages/Previsionale";
import Preventivo from "@/pages/Preventivo";
import Paga from "@/pages/Paga";
import FotoCloud from "@/pages/FotoCloud";
import Galleria from "@/pages/Galleria";
import PaymentResult from "@/pages/PaymentResult";

import { managerAllowed } from "@/lib/roles";

function Protected({ children, adminOnly, staffAllow }) {
  const { user, loading, isAdmin, isStaff, isManager } = useAuth();
  const location = useLocation();
  if (loading) return <div className="h-screen grid place-items-center text-slate-400">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (isManager && !managerAllowed(location.pathname)) return <Navigate to="/dashboard" replace />;
  if (adminOnly && !isAdmin) return <Navigate to={isStaff ? "/trasferimenti" : "/calendario"} replace />;
  if (isStaff && !staffAllow) return <Navigate to="/trasferimenti" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/paga/:id" element={<Paga />} />
      <Route path="/galleria/:token" element={<Galleria />} />
      <Route path="/soggiorno/:token" element={<Galleria kind="stay" />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      <Route path="/voucher/group/:gid" element={<Protected><VoucherGroup /></Protected>} />
      <Route path="/voucher/:id" element={<Protected><Voucher /></Protected>} />
      <Route path="/ricevuta/group/:gid" element={<Protected><RicevutaGroup /></Protected>} />
      <Route path="/ricevuta/:id" element={<Protected><Ricevuta /></Protected>} />
      <Route path="/fattura/:id" element={<Protected adminOnly><Fattura /></Protected>} />
      <Route
        element={
          <Protected staffAllow>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Protected adminOnly><Dashboard /></Protected>} />
        <Route path="/opzioni" element={<Protected adminOnly><OpzioniPrenotazione /></Protected>} />
        <Route path="/acconti-saldi" element={<Protected adminOnly><AccontiSaldi /></Protected>} />
        <Route path="/annuale" element={<Protected adminOnly><Annuale /></Protected>} />
        <Route path="/previsionale" element={<Protected adminOnly><Previsionale /></Protected>} />
        <Route path="/foto" element={<FotoCloud />} />
        <Route path="/preventivo" element={<Protected adminOnly><Preventivo /></Protected>} />
        <Route path="/calendario" element={<Protected staffAllow><Calendario /></Protected>} />
        <Route path="/trasferimenti" element={<Protected staffAllow><Trasferimenti /></Protected>} />
        <Route path="/proprieta" element={<Protected adminOnly><Proprieta /></Protected>} />
        <Route path="/disponibilita" element={<Protected><Disponibilita /></Protected>} />
        <Route path="/ospiti" element={<Protected adminOnly><Ospiti /></Protected>} />
        <Route path="/money" element={<Money />} />
        <Route path="/fatture" element={<Protected adminOnly><Fatture /></Protected>} />
        <Route path="/report" element={<Protected adminOnly><Report /></Protected>} />
        <Route path="/affitti" element={<Protected adminOnly><Affitti /></Protected>} />
        <Route path="/staff" element={<Protected adminOnly><Staff /></Protected>} />
        <Route path="/bar" element={<Protected><Bar /></Protected>} />
        <Route path="/spese-guesthouse" element={<Protected adminOnly><SpeseGuesthouse /></Protected>} />
        <Route path="/amministrazione" element={<Protected adminOnly><Amministrazione /></Protected>} />
        <Route path="/mira" element={<Protected adminOnly><Mira /></Protected>} />
        <Route path="/utenti" element={<Protected adminOnly><Utenti /></Protected>} />
        <Route path="/agenzie" element={<Protected adminOnly><Agenzie /></Protected>} />
        <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
